import React from "react";

import { connect } from "react-redux";

import { addUser } from "store/actions/security";
import API from "api";
import Utils from "utils";
import Publication from "components/Publication";
import "bootstrap/js/dist/carousel";

class Kiosk extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: null,
      items: []
    };
    this.mainSlider = React.createRef();

    API.kioskPublicationCategories(false)
      .then(res => {
        const { data } = res;

        this.setState({
          error: null,
          items: data,
          loading: false
        });
      })
      .catch(error => {
        let message = error.message;

        if (error.response) {
          message = error.response.data.message;
        }

        this.setState({
          error: message,
          items: [],
          loading: false
        });
      });
  }

  onClick = item => e => {
    if (this.props.isAuth) {
      const kioskId = process.env.REACT_APP_KIOSK_ID;
      let rPublication = Object.assign({}, item);

      const params = {
        apiUrl: process.env.REACT_APP_API_URL,
        kiosk: kioskId
        // subKioskId: this.props.user.subKioskId
      };
      const readerUrl = process.env.REACT_APP_READER_URL;
      const publicationReaderUrl = Utils.getPublicationReaderUrl(
        rPublication,
        this.props.apiKey,
        readerUrl,
        params
      );
      window.location.href = publicationReaderUrl;
    } else {
      this.props.history.push("/login");
    }
  };

  render() {
    const { loading, error, items } = this.state;

    if (loading || error) {
      return (
        <div className="App">
          <header className="App-header">
            <div className="d-flex flex-column  my-3">
              {loading && (
                <div className="d-flex flex-row justify-content-center ">
                  <div className="spinner-grow mr-3" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}

              {error && (
                <div className="text-danger text-center h3">
                  {error || "Error lors de chargement des titres"}
                </div>
              )}
            </div>
          </header>
        </div>
      );
    }
    const { kiosk,  } = this.props;
    // kiosk.media_links = [
    //   {
    //     title: "",
    //     sub_title: "",
    //     target_url: "http://ikeafamily.kioskpress.fr/#/publications",
    //     media: {
    //       web_path: require("../1200-400.png")
    //     }
    //   }
    // ];

    return (
      <div className="container-fluid p-0">
        <div className="container">
          <div className="row my-4 ">
            <div
              className={kiosk.aside_media_links.length > 0 ? "col-9" : "col"}
            >
              {kiosk.media_links.length > 0 && (
                <div
                  id="mainSlider"
                  ref={this.mainSlider}
                  className="carousel slide my-4"
                  data-ride="carousel"
                >
                  <ol className="carousel-indicators">
                    {kiosk.media_links.map((item, i) => (
                      <li
                        key={i}
                        data-target="#mainSlider"
                        data-slide-to={i}
                        className={i === 0 ? "active" : ""}
                      ></li>
                    ))}
                  </ol>
                  <div className="carousel-inner">
                    {kiosk.media_links.map((item, i) => (
                      <div
                        key={i}
                        className={`carousel-item ${i === 0 ? "active" : ""}`}
                      >
                        <a
                          href={item.target_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className="d-block w-100"
                            src={item.media.web_path}
                            alt="First slide"
                          />
                        </a>
                        <div className="carousel-caption d-none d-md-block">
                          <h5>{item.title}</h5>
                          <h5>{item.sub_title}</h5>
                        </div>
                      </div>
                    ))}
                  </div>
                  <a
                    className="carousel-control-prev"
                    href="#mainSlider"
                    role="button"
                    data-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a
                    className="carousel-control-next"
                    href="#mainSlider"
                    role="button"
                    data-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>
              )}
            </div>
            {kiosk.aside_media_links.length > 0 && (
              <div className="col ">
                <div className="bg-primary d-flex h-100 flex-column  justify-content-end align-items-stretch">
                  {kiosk.aside_media_links.map((item, i) => {
                    return (
                      <div key={i} className=" bg-danger align-self-stretch">
                        <a
                          href={item.target_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={item.media.web_path}
                            alt={item.media.name}
                            className="img img-fluid"
                          />
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="d-flex flex-row flex-wrap justify-content-center">
            {items.map((item, i) => {
              return (
                <Publication
                  key={i}
                  publication={item}
                  onClick={this.onClick(item)}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.security.user,
  apiKey: state.security.user
    ? state.security.user.api_key
    : process.env.REACT_APP_API_SECRETE,
  kiosk: state.app.kiosk || {},
  isAuth: Boolean(state.security.user)
});

const binActionsToProps = dispatch => ({
  addUser: user => dispatch(addUser(user))
});
export default connect(mapStateToProps, binActionsToProps)(Kiosk);
